import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { PageMeta } from './PageMeta'

export function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <Container sx={{ py: { xs: 10, md: 16 } }}>
      <PageMeta title={t('common.notFound')} noIndex />
      <Stack spacing={3} alignItems="center" sx={{ textAlign: 'center' }}>
        <Box aria-hidden sx={{ fontSize: '4rem', lineHeight: 1 }}>
          🧭
        </Box>
        <Typography variant="h2">{t('common.notFound')}</Typography>
        <Typography variant="subtitle1" color="text.secondary" sx={{ maxWidth: 460 }}>
          {t('common.notFoundBody')}
        </Typography>
        <Button component={RouterLink} to="/" variant="contained" size="large">
          {t('common.backHome')}
        </Button>
      </Stack>
    </Container>
  )
}
